var App = App || {};

App.Donate = (function ($) {
	"use strict";

	function init() {
		$(document).on("submit", "#make-a-donation", function (e) {
			e.preventDefault();

			const $form = $(this);
			$form.find("input").each((_, el) => el.setCustomValidity(""));

			if ($form[0].checkValidity()) {
				var key = $(this).data("key"),
					amount = parseFloat($("#donation-amount").val()),
					cartUrl = $(this).data("cart");

				const formattedPrice = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD'
				}).format(amount);

				App.Commerce
					.Add(key, null, 1, {
						"cartDescription": `Donation amout: ${formattedPrice}`,
						"priceOverride": amount
					})
					.done(function () {
						window.location.href = cartUrl;
					});
			} else {
				applyValidationMessages($form);
			}

			$form.addClass("was-validated");
		});
	}

	function applyValidationMessages($form) {
		$form.find(":invalid").each(function () {
			let msg = "";

			switch (true) {
				case this.validity.valueMissing:
					msg = $(this).data("val-required") || "A value is required.";
					break;
				case this.validity.typeMismatch:
					msg = $(this).data("val-type") || "Incorrect format.";
					break;
				default:
					msg = this.validationMessage || "";
					break;
			}

			$(this).siblings(".field-validation-error").text(msg);
		});
	}
	return {
		init: init
	};

})(jQuery);

$(function () {
	App.Donate.init();
});